import src from "IMAGE";
export default { src, width: 1400, height: 787, blurWidth: 8, blurHeight: 4, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAYAAACzzX7wAAAAG0lEQVR42rXKIQEAAADCsEd/c2iAQ8wNNQv/UIGgT+HKXEQ6AAAAAElFTkSuQmCC"};
